import routePaths from "../../../route/routePaths";
import ContentLayout from "../../../layouts/ContentLayout";
import { useOutletContext } from "react-router-dom";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { faDownload, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { testPlanServices } from "../../../services/api";
import { toast } from "react-toastify";
import messages from "../../../services/api/messages";
import Button from "../../../components/UI/Button";
import { callApiStatus } from "../../../constants";
import PageLoading from "../../../components/CommonPage/PageLoading";
import PageError from "../../../components/CommonPage/PageError";

function ChangeTemplatePage() {
  const [breadcrumb] = useOutletContext();
  const inputRef = useRef();
  const inputId = uuidv4();

  const [loadInitState, setLoadInitState] = useState({
    loadingStatus: callApiStatus.idle,
    data: null,
    error: null,
  });
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);

  const loadInitFile = useCallback(() => {
    setLoadInitState({
      loadingStatus: callApiStatus.loading,
      data: null,
      error: null,
    });

    testPlanServices
      .getTemplateFile()
      .then((response) => {
        if (response.data.result) {
          setLoadInitState({
            loadingStatus: callApiStatus.success,
            data: response.data.result,
            error: null,
          });
          setFileName(response.data.result);
        }
      })
      .catch((error) => {
        toast.error(messages.callApiFail);
        setLoadInitState({
          loadingStatus: callApiStatus.error,
          data: null,
          error: error,
        });
      });
  }, []);

  const handleChangeFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      setFileName(file.name);
    }
  };

  const handleUpload = () => {
    testPlanServices
      .uploadTemplateFile(file)
      .then((res) => {
        if (res) {
          toast.success(messages.update(true));
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDownload = () => {
    setTimeout(() => {
      testPlanServices
        .downloadTemplateFile(loadInitState.data)
        .catch(() => toast.error(messages.downloadFail));
    }, 500);
  };

  useEffect(() => loadInitFile(), [loadInitFile]);

  if (loadInitState.loadingStatus === callApiStatus.loading) {
    return <PageLoading />;
  }

  if (
    loadInitState.loadingStatus === callApiStatus.error ||
    loadInitState.error
  ) {
    return <PageError />;
  }

  if (
    loadInitState.loadingStatus === callApiStatus.success &&
    loadInitState.data
  ) {
    return (
      <ContentLayout
        sideMenuLinkOptions={[
          {
            linkTo: routePaths.createTestPlan,
            linkTitle: "計画書の作成",
          },
          {
            linkTo: routePaths.updateTestPlan,
            linkTitle: "計画書の修正",
          },
          {
            linkTo: routePaths.changeTemplate,
            linkTitle: "計画書テンプレート変更",
          },
          {linkTo: routePaths.topMenu, linkTitle: "トップへ戻る"},
        ]}
        breadcrumb={breadcrumb}
      >
        <div className="w-full h-auto">
          <div className="flex justify-between pb-4">
            <div className="flex items-end">計画書テンプレート変更</div>
            <div className="flex gap-4">
              <Button
                type={file ? 'primary' : 'disabled'}
                onClick={handleUpload}
                disabled={!file}
              >
                変更する
              </Button>
              <button
                className={`h-full flex justify-center items-center`}
                onClick={handleDownload}
              >
                <FontAwesomeIcon icon={faDownload} size="lg"/>
              </button>
            </div>
          </div>
          <div className="flex">
            <div
              className="relative cursor-pointer flex-1"
              onClick={() => {
                inputRef.current && inputRef.current.click();
              }}
            >
              <div className="p-3 text-sm border rounded-xl border-[#B3B3B3] !outline-none bg-[#ebebeb]">
                <p>{fileName ? fileName : 'ファイルを選択'}</p>
              </div>
              <input
                ref={inputRef}
                id={inputId}
                name={inputId}
                type="file"
                onChange={handleChangeFile}
                className="hidden"
                accept={'.docx'}
              />
            </div>
          </div>
        </div>
      </ContentLayout>
    );
  }

  return null;
}

export default ChangeTemplatePage;
